var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClock = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3ZM12 19.2C8.02355 19.2 4.8 15.9764 4.8 12C4.8 8.02355 8.02355 4.8 12 4.8C15.9764 4.8 19.2 8.02355 19.2 12C19.2 15.9764 15.9764 19.2 12 19.2ZM14.7898 12.5669L12.9 11.4776V7.50239C12.9 7.00533 12.4971 6.60239 12 6.60239C11.5029 6.60239 11.1 7.00533 11.1 7.50239V12.1137C11.1055 12.1756 11.1208 12.2363 11.1453 12.2934C11.164 12.3467 11.1882 12.3978 11.2177 12.446C11.2423 12.4971 11.2724 12.5454 11.3075 12.5899L11.4514 12.7068L11.5309 12.7863L13.8724 14.1307C14.1521 14.2915 14.4964 14.2908 14.7756 14.1289C15.0547 13.967 15.2262 13.6684 15.2256 13.3458C15.2249 13.0231 15.0521 12.7253 14.7724 12.5645L14.7898 12.5669Z",
    fill: "#121214"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Clock.3f763969.svg";
export { ForwardRef as ReactComponent };